import React from 'react';
import { connect } from 'react-redux';
import { MediaQuery } from '../../../constants/MediaQuerySizes';
import { Typography, LinearProgress } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import Box from '@mui/material/Box';
import isEmpty from 'lodash.isempty';
import { getAudioVolume } from '../../../utilities/storageUtilities';
import { exportsActions } from './store';
import TunebatSongMasteringLink from './TunebatSongMasteringLink';
import { ExportMessages } from './ExportsPageConstants';
import ProgressSubtitle from './components/ProgressSubtitle';
import { getOrdinalSuffix } from '../../../utilities/stringUtilities';

const styles = (theme) => ({
    viewContainer: {
        marginTop: theme.spacing(2),
        height: 'calc(100vh - 100px)',
        padding: 0,
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down(MediaQuery.MIN_DESKTOP)]: {
            height: 'auto',
            padding: "0 3%"
        }
    },
    contentWrapper: {
        margin: 0,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '65%',
        [theme.breakpoints.down(MediaQuery.MIN_DESKTOP)]: {
            top: 0,
            left: 0,
            width: '100%',
            position: 'relative',
            transform: 'initial',
            margin: '45px 0',
        }
    },
    videoPlayer: {
        filter: 'drop-shadow(rgba(0, 0, 0, 0.75) 0px 4px 5px)',
        maxWidth: '100%',
        height: '100%',
        [theme.breakpoints.down(MediaQuery.MIN_DESKTOP)]: {
            minHeight: '100%', 
            minWidth: '100%', 
            height: 'auto',
            width: 'auto ' 
        }
    },
    title: {
        marginBottom: "10px",
    },
    description: {
        marginBottom: theme.spacing(2),
    },
    progressBar: {
        height: theme.spacing(1)
    }
});

class ExportVideoView extends React.Component {

    render() {
        const { classes, isVideoViewLoading, selectedExport } = this.props;
        var content = undefined;
        
        if (!isEmpty(selectedExport) && !isVideoViewLoading) {
            switch (selectedExport.status) {
                case 'Completed':
                    content = this.renderVideoPlayer(selectedExport);
                    break;
                case 'Failed':
                    content = this.renderExportInformation(classes, ExportMessages.failed.title, ExportMessages.failed.description(selectedExport.rendererFailureCode, selectedExport.watermarked));
                    break;
                case 'Canceled':
                    content = this.renderExportInformation(classes, ExportMessages.canceled.title, ExportMessages.canceled.description);
                    break;
                default:
                    const title = selectedExport.queuePosition ? `${selectedExport.queuePosition}${getOrdinalSuffix(selectedExport.queuePosition)} in your queue` : ExportMessages.initialization.title;
                    content = this.renderExportProgress(classes, selectedExport.progress, title);
            }
        }

        return (
            <Box className={classes.viewContainer}>
                {isVideoViewLoading && <LinearProgress />}
                {content}
            </Box>
        );
    };

    renderVideoPlayer(selectedExport) {
        const { classes, videoPlayerVolume } = this.props;

        return (
            <video
                className={classes.videoPlayer}
                controls
                preload="auto"
                loop
                playsInline
                crossOrigin="anonymous"
                key={selectedExport?.videoFileUrl}
                onLoadStart={(e) => {
                e.target.volume = videoPlayerVolume
                }}
            >
                <source src={selectedExport?.videoFileUrl} type="video/mp4" />
                Your browser does not support the video tag.
             </video>
        );
    };

    renderExportInformation(classes, title, description) {
        return (
            <Box className={classes.contentWrapper}>
                <Typography className={classes.title}>
                    {title}
                </Typography>
                <Typography className={classes.description}>
                    {description}
                </Typography>
            </Box>
        );
    };

    renderExportProgress(classes, exportProgress, title) {
        const { accountDetails } = this.props;

        return (
            <Box className={classes.contentWrapper}>
                {!Boolean(exportProgress) ?
                    <>
                        <Typography 
                            className={classes.title} 
                            variant='h6' 
                            component='p'
                        >
                            {title}
                        </Typography>
                        <ProgressSubtitle receiveVideoNotificationEmails={accountDetails?.receiveVideoNotificationEmails} />
                        <LinearProgress 
                            variant='determinate' 
                            value={0}
                            className={classes.progressBar}
                        />
                         <TunebatSongMasteringLink/>
                    </>
                :
                    <>
                        <Typography 
                            className={classes.title} 
                            variant='h6' 
                            component='p'
                        >
                            {`${exportProgress.step} ${exportProgress.value ? Math.round(exportProgress.value) + '%' : ''}`}
                        </Typography>
                        <ProgressSubtitle receiveVideoNotificationEmails={accountDetails?.receiveVideoNotificationEmails} />
                        <LinearProgress
                            variant={exportProgress.value ? 'determinate' : 'indeterminate'}
                            value={exportProgress.value ? Math.round(exportProgress.value) : null} 
                            className={classes.progressBar}
                        />
                        <TunebatSongMasteringLink/>
                    </>
                }
            </Box>
        );
    };

    componentDidMount() {
        const { setProperty } = this.props;
        setProperty('videoPlayerVolume', getAudioVolume());
    }
}

const mapStateToProps = (state) => {
    const { 
        isVideoViewLoading,
        selectedExport,
        videoPlayerVolume
    } = state.exports;

    const { accountDetails } = state.app;

    return {
        accountDetails,
        isVideoViewLoading,
        selectedExport,
        videoPlayerVolume
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(exportsActions.setProperty(key, value));

    return {
        setProperty
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(ExportVideoView, styles));